module.exports = __webpack_public_path__ + "img/dialog_bg.c00c028a.bff617a7.png";